var link_viewer_default = {
  "fontElementMap": "-XWiB",
  "link": "_3O4gy",
  "linkInEditor": "_8ZWAl",
  "linkInViewer": "rsYGG",
  "toolbarUrlContainer": "pwz0V",
  "toolbarUrl": "Csl64",
  "toolbarUrlAnchor": "gNxBA"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
